function ErrorPage() {
    return (
        <h2 className="container text-center my-5">Error 404: Page Not Found</h2>
    );
}

export default ErrorPage;